import { jsx as _jsx } from "react/jsx-runtime";
import { RelationshipsSection } from '../RelationshipsSection.js';
export function RelationshipsTab(props) {
    const { character, canEdit } = props;
    return _jsx(RelationshipsSection, { character: character, canEdit: canEdit });
}
//# sourceMappingURL=RelationshipsTab.js.map